import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["isShow", "defaultType", "dataSource", "events"];
import React, { useState, useEffect } from 'react';
import classnames from 'classnames';
import { parseParam } from '@U/tool';
import { subscribe, getState } from '@/store';
import { useLocalClick } from '@/components/Button'; // 监听表单变化获取被保人信息  判断是否显示简单描述
// 监听表单 判断是否所有被保人都不抽烟

const useVisible = () => {
  const [data = {}, setData] = useState({});
  const {
    insuredList = []
  } = data;
  useEffect(() => {// const fn = async () => {
    //   const newData = await getFetchData() || {};
    //   setData(newData);
    // };
    // subscribeTree(fn, 'formValues');
  }, []);
  return insuredList.every((item = {}) => {
    const {
      person
    } = item;

    if (!person) {
      return true;
    }

    return person.smoking !== 'Y';
  });
}; // 健康险操作栏简单描述组件


const SimpleRemark = /*#__PURE__*/React.forwardRef((props = {}, ref) => {
  const {
    attrs,
    className
  } = props;

  const {
    isShow = false,
    defaultType = 'cumstomer',
    dataSource = [],
    events = {}
  } = attrs,
        others = _objectWithoutProperties(attrs, _excluded);

  const visible = useVisible();
  const [text = '', setText] = useState('');
  const [configJson = {}, setConfigJson] = useState({});
  const params = parseParam(window.location.search.split('?')[1]) || {};
  const {
    purchaseUserId = ''
  } = params;
  const cls = classnames({
    'components-simple-remark-render': true,
    [className]: !!className
  });
  const onClick = useLocalClick(events);
  useEffect(() => {
    setConfigJson(getState('configJson') || {});
    subscribe(setConfigJson, 'configJson');
  }, []);
  useEffect(() => {
    const curr = dataSource.find((item = {}) => item.type === defaultType) || {};
    const {
      type,
      value = '优选价格'
    } = curr;
    const {
      goodsAlias = '商品别名'
    } = configJson;

    switch (type) {
      case 'cumstomer':
        setText(value);
        break;

      case 'interface':
      default:
        setText(goodsAlias);
        break;
    }
  }, [defaultType, dataSource, configJson]);

  if (!isShow) {
    return null;
  }

  if (!visible) {
    return null;
  } // 华米移除优选价格标示


  if (purchaseUserId.includes('HUAMI')) {
    return null;
  }

  return /*#__PURE__*/React.createElement("div", _extends({
    ref: ref,
    className: cls,
    onClick: onClick
  }, others));
});
export default SimpleRemark;